<template>
    <component
        :is="areMarketsShownOutside ? 'portal' : 'div'"
        to="special-markets-sidebar"
    >
        <div class="event-row__expanded-markets--terminal" v-if="specialEvent">
            <div class="special-event-market__container">
                <SpecialEvent
                    :markets="specialEvent.markets"
                    :footer="specialEvent.footer"
                    :header="specialEvent.header"
                    :isResults="false"
                    :selections="selections"
                    @oddClick="onOddClick"
                    :isForSportMarket="isForSportMarket"
                />
            </div>
        </div>
    </component>
</template>

<script>
    // ATTENTION colleague slicer. Please remove the styles from this component
    // they're meeant to be temporary
    import { mapGetters, mapActions } from 'vuex';
    import { SelectionType } from '@models/shared/betSlip/betSlipEnums';
    import SpecialEvent from '@src/terminal/app/modules/shared/special/SpecialEvent.vue';

    export default {
        props: {
            specialOfferId: {
                type: Number,
                required: true,
            },
            areMarketsShownOutside: {
                type: Boolean,
                required: true,
            },
            isForSportMarket: {
                type: Boolean,
                required: true,
            }
        },
        computed: {
            ...mapGetters('data/specialOffer', [
                'specialEventById'
            ]),
            ...mapGetters('ui/sportOffer/betSlip', [
                'selections',
            ]),
            specialEvent() {
                return this.specialEventById(this.specialOfferId);
            },
            specialMarkets() {
                if (this.specialEvent && this.specialEvent.isAvailableForBetting()) {
                    return this.filterAvailableChildren(this.specialEvent, 'markets');
                }
                // @UX how do we handle this
                return [];
            }
        },
        methods: {
            ...mapActions('ui/sportOffer/betSlip', [
                'toggleAddRemoveSelection',
            ]),
            filterAvailableChildren(parent, childName) {
                const now = new Date();
                return parent[childName].filter((child) => child.isAvailableForBetting(now));
            },
            isSelected(odd) {
                if (!odd.value) {
                    return false;
                }
                return this.selections.find((selection) => selection.getOddId() === odd.id);
            },
            onOddClick(odd) {
                this.toggleAddRemoveSelection({
                    eventId: this.specialOfferId,
                    oddId: odd.id,
                    type: SelectionType.special,
                });
            }
        },
        components: {
            SpecialEvent,
        }
    };
</script>

<style scoped lang="scss">
    .market {
        display: flex;
        flex-direction: column;
    }

    .market-header, .market-footer {
        height: 24px;
        background-color: lightgrey;
        font-weight: bold;
    }

    .special-market-event {
        display: flex;
        justify-content: space-between;
    }

    .special-odd {
        border: 1px solid black;
        cursor: pointer;

        &.selected {
            background-color: red;
        }
    }
</style>



// WEBPACK FOOTER //
// src/terminal/app/modules/eventGrid/components/SpecialMarkets.vue